module.exports = __webpack_public_path__ + "static/media/dani26.58f24b4e.jpg";